import { render, staticRenderFns } from "./LogTab.vue?vue&type=template&id=37c7198e&scoped=true&"
import script from "./LogTab.vue?vue&type=script&lang=ts&"
export * from "./LogTab.vue?vue&type=script&lang=ts&"
import style0 from "./LogTab.vue?vue&type=style&index=0&id=37c7198e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c7198e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VContainer,VSpacer})
